<section class="slider-shell card">
  <div class="filter-row">
    <button class="chip" *ngFor="let category of ['All', 'Interior', 'Exterior', '3D Design']" (click)="switchCategory(category)" [class.active]="selectedCategory === category">
      {{ category }}
    </button>
  </div>
  <div class="slider-image" *ngIf="currentItem; else empty">
    <div class="slider-main-image">
      <button class="btn hidebtn" type="button" (click)="previous()"><i class="fa-solid fa-arrow-left"></i></button>
      <img [src]="currentImage" [alt]="currentItem.title" />
      <button class="btn hidebtn" type="button" (click)="next()"><i class="fa-solid fa-arrow-right"></i></button>
    </div>
    <div class="overlay">
      <span class="category-badge">{{ currentItem.category }}</span>
      <h3>{{ currentItem.title }}</h3>
      <p>{{ currentItem.caption || 'Crafted with precision and luxury' }}</p>
    </div>
  </div>
  <ng-template #empty>
    <div class="empty-state">No gallery items available yet.</div>
  </ng-template>
  <div class="slider-controls" *ngIf="visibleItems.length">
    <div class="thumb-row">
      <button class="thumb" *ngFor="let item of visibleItems; let index = index" (click)="select(index)" [class.active]="activeIndex === index">
        <img [src]="item.images?.[0] || item.url" [alt]="item.title" />
      </button>
    </div>
  </div>
</section>
